import { defineMessages } from 'react-intl'

const scope = `procurify.budgets.components.BudgetCustomFieldSelect`

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Select a custom field',
  },
  inactiveCustomFieldLabel: {
    id: `${scope}.inactiveCustomFieldLabel`,
    defaultMessage: '{name} (inactive)',
  },
})
